import { Cliente } from './cliente';
import { Produto } from './produto';
import { Vendedor } from './vendedor';
import { Usuario } from './usuario';

export class Venda {
  id:  number | null = null;
  itens: ItemVenda[] = [];
  subtotal: number = 0; // soma dos preços base (preco * qtd)

  // descontos/acréscimos informados a nível de venda (extras pelo usuário)
  desconto: number = 0; // extra desconto de venda (modal)
  acrescimo: number = 0; // extra acrescimo de venda (modal)

  // totais calculados a partir dos itens
  itensDesconto: number = 0; // soma dos descontos dos itens
  itensAcrescimo: number = 0; // soma dos acréscimos dos itens

  cliente: Cliente | any = new Cliente();
  vendedor: Vendedor | any = new Vendedor();
  usuario: Usuario | any = new Usuario();
  pagamento: MetodoPagamento = MetodoPagamento.pix;
  observacao: string = '';
  vendaSituacao: VendaSituacao = VendaSituacao.pedido;

  constructor() {}

  public addItemVenda(value: ItemVenda) {
    // normalizar números
    value.quantidade = Number(value.quantidade) || 0;
    value.valorAcrescimo = Number(value.valorAcrescimo) || 0;
    value.valorDesconto = Number(value.valorDesconto) || 0;
    const preco = Number(value.produto?.preco) || 0;

    const subtotalItem = value.quantidade * preco;
    value.valorTotal = subtotalItem + value.valorAcrescimo - value.valorDesconto;

    this.itens.push(value);

    // recalcula totais a partir dos itens para evitar inconsistências
    this.recalculateTotals();
  }

  /**
   * Recalcula subtotal, itensDesconto e itensAcrescimo a partir dos itens atuais.
   * Não sobrescreve os valores de `desconto` e `acrescimo` que representam ajustes a nível de venda.
   */
  public recalculateTotals() {
    this.subtotal = this.itens.reduce((acc, it) => {
      const preco = Number(it.produto?.preco) || 0;
      const qtd = Number(it.quantidade) || 0;
      return acc + preco * qtd;
    }, 0);

    this.itensAcrescimo = this.itens.reduce((acc, it) => acc + (Number(it.valorAcrescimo) || 0), 0);
    this.itensDesconto = this.itens.reduce((acc, it) => acc + (Number(it.valorDesconto) || 0), 0);
  }

  get total() {
    // total = subtotal + (itensAcrescimo + acrescimo) - (itensDesconto + desconto)
    return (this.subtotal + this.itensAcrescimo + (Number(this.acrescimo) || 0)) - (this.itensDesconto + (Number(this.desconto) || 0));
  }

  public removerItemVenda(index: number) {
    if (index >= 0 && index < this.itens.length) {
      this.itens.splice(index, 1);
      // recalcula após remoção
      this.recalculateTotals();
    }
  }
}

export class ItemVenda {
  produto: Produto = new Produto();
  quantidade: number = 1;
  valorAcrescimo: number = 0;
  valorDesconto: number = 0;
  valorTotal: number = 0;
}

export enum MetodoPagamento {
  pix = 'PIX',
  dinheiro = 'DINHEIRO',
  transferencia = 'TRANSFERENCIA',
  prazo = 'PRAZO',
  cartaoDebito = 'CARTAO_DEBITO',
  cartao1x = 'CARTAO_1X',
  cartao2x = 'CARTAO_2X',
  cartao3x = 'CARTAO_3X',
  cartao4x = 'CARTAO_4X',
  cartao5x = 'CARTAO_5X',
  cartao6x = 'CARTAO_6X',
  cartao7x = 'CARTAO_7X',
  cartao8x = 'CARTAO_8X',
  cartao9x = 'CARTAO_9X',
  cartao10x = 'CARTAO_10X',
  cartao11x = 'CARTAO_11X',
  cartao12x = 'CARTAO_12X',
  cartao13x = 'CARTAO_13X',
  cartao14x = 'CARTAO_14X',
  cartao15x = 'CARTAO_15X',
  cartao16x = 'CARTAO_16X',
  cartao17x = 'CARTAO_17X',
  cartao18x = 'CARTAO_18X'
}

export enum VendaSituacao {
orcamento = "ORCAMENTO",
pedido = "PEDIDO",
venda = "VENDA",
cancelada = "CANCELADA"
}
